// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const DownloadSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 16h-.275l-3.851-4.332-.748.664 3.851 4.332a1 1 0 00.748.336h1.55a1 1 0 00.748-.336l3.85-4.332-.747-.664L12.276 16H12V3h-1v13zm-9 3v-5h1v5a1 1 0 001 1h15a1 1 0 001-1v-5h1v5a2 2 0 01-2 2H4a2 2 0 01-2-2z"
      />
    </svg>
  )
}
